import { CheckedState } from '@radix-ui/react-checkbox';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { MostSearchedResult } from '@/types/most-search-type';
import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { Checkbox } from '@/components/ui/checkbox.component';
import { slugify } from '@/utils/formatters/slugfy';

export function CheckboxProcedure({
  procedure,
  handleSelectProcedure,
  isChecked,
}: {
  procedure: MostSearchedResult | SearchResult | SelectedProcedures;
  handleSelectProcedure: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => void;
  isChecked: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => boolean;
}) {
  return (
    <div
      className="flex items-center py-5 pl-5 border-b hover:bg-green-50 cursor-pointer"
      onClick={() => handleSelectProcedure(procedure)}
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_PROCEDURES_CHECKBOX}
    >
      <Checkbox
        checked={isChecked(procedure) as unknown as CheckedState}
        onClick={() => handleSelectProcedure(procedure)}
        data-testid={`${slugify(procedure.displayName || '')}--checkbox-procedure`}
      >
        {procedure.displayName}
      </Checkbox>
    </div>
  );
}
